// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* base-button.css */
.base-button {
    background-color: var(--color-background);
    color: var(--color-foreground);
    stroke: var(--color-foreground);
    fill: var(--color-foreground);
    cursor: pointer;
    font: inherit;
    border: none;
    border-radius: 4px;
    padding: 0.5em 0.5em;
    transition: background-color 0.3s ease, color 0.3s ease, stroke 0.3s ease, fill 0.3s ease;
}

@media (hover: hover) and (pointer: fine) {
    .base-button:hover {
        background-color: var(--color-hover-back);
        color: var(--color-hover-fore);
        stroke: var(--color-hover-fore);
        fill: var(--color-hover-fore);
    }
}

    .base-button:active {
        background-color: var(--color-active-back);
        color: var(--color-active-fore);
        stroke: var(--color-active-fore);
        fill: var(--color-active-fore);
    }

    .base-button:disabled {
        background-color: var(--color-disabled-back);
        color: var(--color-disabled-fore);
        stroke: var(--color-disabled-fore);
        fill: var(--color-disabled-fore);
        cursor: not-allowed;
        pointer-events: none;
        transition: none;
    }

    .component-button {
        background-color: var(--color-component-background);
        color: var(--color-component-foreground);
        stroke: var(--color-component-foreground);
        fill: var(--color-component-foreground);
    }

@media (hover: hover) and (pointer: fine) {
    .component-button:hover {
        background-color: var(--color-component-hover-back);
        color: var(--color-component-hover-fore);
        stroke: var(--color-component-hover-fore);
        fill: var(--color-component-hover-fore);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Controls/Button/css/BaseButton.css"],"names":[],"mappings":"AACA,oBAAoB;AACpB;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,yFAAyF;AAC7F;;AAEA;IACI;QACI,yCAAyC;QACzC,8BAA8B;QAC9B,+BAA+B;QAC/B,6BAA6B;IACjC;AACJ;;IAEI;QACI,0CAA0C;QAC1C,+BAA+B;QAC/B,gCAAgC;QAChC,8BAA8B;IAClC;;IAEA;QACI,4CAA4C;QAC5C,iCAAiC;QACjC,kCAAkC;QAClC,gCAAgC;QAChC,mBAAmB;QACnB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,mDAAmD;QACnD,wCAAwC;QACxC,yCAAyC;QACzC,uCAAuC;IAC3C;;AAEJ;IACI;QACI,mDAAmD;QACnD,wCAAwC;QACxC,yCAAyC;QACzC,uCAAuC;IAC3C;AACJ","sourcesContent":["@import '../../../css/App.css';\r\n/* base-button.css */\r\n.base-button {\r\n    background-color: var(--color-background);\r\n    color: var(--color-foreground);\r\n    stroke: var(--color-foreground);\r\n    fill: var(--color-foreground);\r\n    cursor: pointer;\r\n    font: inherit;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 0.5em 0.5em;\r\n    transition: background-color 0.3s ease, color 0.3s ease, stroke 0.3s ease, fill 0.3s ease;\r\n}\r\n\r\n@media (hover: hover) and (pointer: fine) {\r\n    .base-button:hover {\r\n        background-color: var(--color-hover-back);\r\n        color: var(--color-hover-fore);\r\n        stroke: var(--color-hover-fore);\r\n        fill: var(--color-hover-fore);\r\n    }\r\n}\r\n\r\n    .base-button:active {\r\n        background-color: var(--color-active-back);\r\n        color: var(--color-active-fore);\r\n        stroke: var(--color-active-fore);\r\n        fill: var(--color-active-fore);\r\n    }\r\n\r\n    .base-button:disabled {\r\n        background-color: var(--color-disabled-back);\r\n        color: var(--color-disabled-fore);\r\n        stroke: var(--color-disabled-fore);\r\n        fill: var(--color-disabled-fore);\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n        transition: none;\r\n    }\r\n\r\n    .component-button {\r\n        background-color: var(--color-component-background);\r\n        color: var(--color-component-foreground);\r\n        stroke: var(--color-component-foreground);\r\n        fill: var(--color-component-foreground);\r\n    }\r\n\r\n@media (hover: hover) and (pointer: fine) {\r\n    .component-button:hover {\r\n        background-color: var(--color-component-hover-back);\r\n        color: var(--color-component-hover-fore);\r\n        stroke: var(--color-component-hover-fore);\r\n        fill: var(--color-component-hover-fore);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
